// extracted by mini-css-extract-plugin
export default {"container":"styles_container__D97RY","input":"styles_input__8kIAj","input_per_page":"styles_input_per_page__X8NMc"};